import styled from '@vodafoneziggo/sandwich/theme';

export const HeaderIcon = styled.svg`
  width: 1.225rem;
  height: 1.225rem;
  fill: ${(props) => props.theme.colors.white};
`;
